import ChallengeEffect from './ChallengeEffect';
import HttpErrorResponseModel from '../../models/HttpErrorResponseModel';
import TransferModel from './models/TransferModel';
import OperationModel from './models/OperationModel';
import ActionUtility from '../../utilities/ActionUtility';
import { ReduxDispatch } from '../../models/ReduxProps';
import IStore from '../../models/IStore';
import moment from 'moment';
import { redirectOnChallengeTransactionError } from 'helpers/Redirector';

type ActionUnion = undefined | HttpErrorResponseModel | TransferModel | OperationModel;

export default class ChallengeAction {
    public static readonly REQUEST_DO_TRANSFER_FXN: string = 'ChallengeAction.REQUEST_DO_TRANSFER_FXN';
    public static readonly REQUEST_DO_TRANSFER_FXN_FINISHED: string = 'ChallengeAction.REQUEST_DO_TRANSFER_FXN_FINISHED';

    public static readonly REQUEST_DO_OPERATION_FXN: string = 'ChallengeAction.REQUEST_DO_OPERATION_FXN';
    public static readonly REQUEST_DO_OPERATION_FXN_FINISHED: string = 'ChallengeAction.REQUEST_DO_OPERATION_FXN_FINISHED';

    public static readonly SET_QUERY_STRING: string = 'ChallengeAction.SET_QUERY_STRING';
    public static readonly SET_CURRENT_TRANSACTION: string = 'ChallengeAction.SET_CURRENT_TRANSACTION';
    public static readonly SET_TRANSACTION_ONINIT: string = 'ChallengeAction.SET_TRANSACTION_ONINIT';
    public static readonly SET_COUNTER: string = 'ChallengeAction.SET_COUNTER';
    public static readonly numberRegex = /^\d+$/;

    public static requestDoTransactionFx(params: any, token: string, opKey: string, counter: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore): Promise<void> => {
            if (!params.jwt) {
                const handshake = getState().handshake.handshake;
                console.error('jwt not found');
                if (handshake && handshake.challengeUrls)
                    redirectOnChallengeTransactionError(handshake.challengeUrls.onErrorRedirect, 'jwt not found', params.trk || '');
                return;
            }
            const coreRecipient = params.rpi !== undefined ? this.numberRegex.test(params.rpi) : false;
            let args = {
                externalTrackingId: params.trk,
                token: params.jwt,
                operationKey: opKey,
                dynamicKey: token,
                originAccount: params.oac,
                destinationAccount: params.rpi === undefined ? params.dac : '',
                recipientId: params.rpi !== undefined ? params.rpi : '00000000-0000-0000-0000-000000000000',
                amount: params.amt,
                conceptReference: params.con,
                numericReference: moment().format('DDMMYYYY'),
                aditionalInformation: 'Envio KAAX',
                ipAddress: params.ipa,
                counter: counter,
                coreRecipient,
                geolocation: params.geolocation,
            };
            await ActionUtility.createThunkEffect<TransferModel>(
                dispatch,
                ChallengeAction.REQUEST_DO_TRANSFER_FXN,
                ChallengeEffect.requestDoTransferFx,
                args
            )
                .then((data: any) => {
                    const handshake = getState().handshake.handshake;
                    if (handshake && handshake.challengeUrls) {
                        if (handshake.challengeUrls.onSuccessRedirect && data.isSuccesful && data.externalTrackingId !== undefined) {
                            window.location.href = `${handshake.challengeUrls.onSuccessRedirect}/?res=${data.isSuccesful}&msg=${data.message}&crf=${data.coreFolio}&itr=${data.trackingKey}&trk=${data.externalTrackingId}&oac=${data.originAccount}&dac=${data.destinationccount}&odt=${data.operationDate}`;
                        } else {
                            if (handshake.challengeUrls.onErrorRedirect) {
                                const error = data.raw && data.raw.data ? data.raw.data : data;
                                const errorMessage = error.message || `${data.status} | ${data.message}`;
                                const trk = error?.externalTrackingId || params.trk;
                                redirectOnChallengeTransactionError(handshake.challengeUrls.onErrorRedirect, errorMessage, trk);
                            }
                        }
                    }
                })
                .catch((err: any) => {
                    console.error(err);
                });
        };
    }

    static SetQueryString(query: any): any {
        return ActionUtility.createAction(ChallengeAction.SET_QUERY_STRING, query);
    }

    public static requestDoOperationFx(params: any, token: string, counter: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore): Promise<void> => {
            if (!params.jwt) {
                const handshake = getState().handshake.handshake;
                console.error('jwt not found');
                if (handshake && handshake.challengeUrls)
                    redirectOnChallengeTransactionError(handshake.challengeUrls.onErrorRedirect, 'jwt not found', params.trk || '');
                return;
            }
            const coreRecipient = params.rid !== undefined ? this.numberRegex.test(params.rid) : false;
            let args = {
                externalTrackingId: params.trk,
                token: params.jwt,
                dynamicKey: token,
                transactionId: params.tid,
                currencyReceive: params.crr,
                currencyDelivery: params.crd,
                amountCharge: params.amc,
                amountPayment: params.amp,
                exchangeRate: params.exr,
                exchangeRateMesa: params.exm,
                accountCharge: params.acc,
                accountPayment: params.rid === undefined ? params.acp : '',
                recipientId: params.rid !== undefined ? params.rid : '00000000-0000-0000-0000-000000000000',
                paymentReason: params.pyr,
                paymentReasonId: params.pid,
                counter: counter,
                tot: params.tot,
                ope: params.ope,
                coreRecipient,
                con: params.con,
                geolocation: params.geolocation,
            };
            await ActionUtility.createThunkEffect<OperationModel>(
                dispatch,
                ChallengeAction.REQUEST_DO_OPERATION_FXN,
                ChallengeEffect.requestDoOperationFx,
                args
            ).then((data: any) => {
                const handshake = getState().handshake.handshake;
                if (handshake && handshake.challengeUrls) {
                    if (handshake.challengeUrls.onSuccessRedirect && data.isSuccesful && data.externalTrackingId !== undefined) {
                        window.location.href = `${handshake.challengeUrls.onSuccessRedirect}/?res=${data.isSuccesful}&msg=${data.message}&dil=${data.dil}&trk=${data.externalTrackingId}`;
                    } else {
                        if (handshake.challengeUrls.onErrorRedirect) {
                            const error = data.raw && data.raw.data ? data.raw.data : data;
                            const errorMessage = error.message || `${data.status} | ${data.message}`;
                            const trk = error?.externalTrackingId || params.trk;
                            redirectOnChallengeTransactionError(handshake.challengeUrls.onErrorRedirect, errorMessage, trk);
                        }
                    }
                }
            });
        };
    }

    public static SetCurrentTransaction(value: string): any {
        return ActionUtility.createAction(ChallengeAction.SET_CURRENT_TRANSACTION, value);
    }

    public static SetTransactionOnInit(value: boolean): any {
        return ActionUtility.createAction(ChallengeAction.SET_TRANSACTION_ONINIT, value);
    }

    public static SetCounter(value: number): any {
        return ActionUtility.createAction(ChallengeAction.SET_COUNTER, value);
    }
}
